import React, { Component } from 'react';
import { Row, Col, Table, Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faKey, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import keyVaultSecretService from '../../services/KeyVaultSecretService';
import OrganizationService from '../../services/organizationService';
import '../../styles/spm.css';

class LayerJotToken extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditModal: false,
            showDeleteModal: false,
            layerjotModalHeaderText: "",
            token: {
                id: props.organizationId,
                orgUUID: props.layerJotOrgIdentifier,
                bearerToken: ''
            },
            tableData: {
                orgUUID: '',
                bearerToken: ''
            },
            disabled: false,
            secretName: 'lj-token-' + props.orgIdentifier,
            error: '',
            isSaveDisabled: true
        };

        this.getToken = this.getToken.bind(this);
        this.showNewModal = this.showNewModal.bind(this);
        this.showEditModal = this.showEditModal.bind(this);
        this.hideEditModal = this.hideEditModal.bind(this);
        this.showDeleteModal = this.showDeleteModal.bind(this);
        this.hideDeleteModal = this.hideDeleteModal.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUserInput = this.handleUserInput.bind(this);
    }

    async componentDidMount() {
        await this.getToken();
    }

    getToken() {
        keyVaultSecretService.get(this.state.secretName)
            .then(response => {
                if (response.data.success) {
                    let tokenResponse = response.data.payload;
                    this.setState({
                        tableData: {
                            orgUUID: this.props.layerJotOrgIdentifier,
                            bearerToken: tokenResponse
                        }
                    });
                }
            });
    }

    showEditModal() {
        this.setState({
            layerjotModalHeaderText: 'Edit LayerJot Token Secret',
            showEditModal: true,
            token: {
                ...this.state.token,
                orgUUID: this.state.tableData.orgUUID,
                bearerToken: this.state.tableData.bearerToken
            }
        });
    }
    showNewModal() {
        if (!this.state.disabled) {
            this.setState({
                token: {
                    id: this.props.organizationId,
                    orgUUID: '',
                    bearerToken: ''
                },
                layerjotModalHeaderText: 'Create New LayerJot Token Secret',
                showEditModal: true,
                disabled: true,
                isSaveDisabled: true
            });
        }
    }
    hideEditModal() {
        this.setState({
            layerjotModalHeaderText: 'Edit New LayerJot Token Secret',
            showEditModal: false,
            disabled: false,
            error: '',
            isSaveDisabled: true
        });
    }

    showDeleteModal() {
        this.setState({
            showDeleteModal: true
        });
    }
    hideDeleteModal() {
        this.setState({
            showDeleteModal: false
        });
    }

    async handleDelete() {
        this.hideDeleteModal();

        const orgInfo = {
            id: this.props.organizationId,
            layerJotOrgIdentifier: null
        }

        const orgResponse = await OrganizationService.updateLayerJotOrgIdentifier(orgInfo);
        const keyVaultResponse = await keyVaultSecretService.delete(this.state.secretName);

        if (orgResponse.data.success && keyVaultResponse.data.success) {
            this.setState({
                tableData: {
                    orgUUID: '',
                    bearerToken: ''
                }
            });
            this.props.modifyState("layerJotOrgIdentifier", '');
        }
    }

    validateGUID(guid) {
        const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        return guidPattern.test(guid);
    }

    async handleSave() {
        if (!this.validateGUID(this.state.token.orgUUID)) {
            this.setState({ error: 'Invalid GUID format for orgUUID.' });
            return;
        }

        const orgInfo = {
            id: this.props.organizationId,
            layerJotOrgIdentifier: this.state.token.orgUUID
        }

        const orgResponse = await OrganizationService.updateLayerJotOrgIdentifier(orgInfo);

        const tokenInfo = {
            id: this.props.organizationId,
            secretName: this.state.secretName,
            bearerToken: this.state.token.bearerToken,
            layerjotOrgUUID: this.state.token.orgUUID
        }

        let keyVaultResult = null;
        const keyVaultResponse = await keyVaultSecretService.set(tokenInfo);
        if (keyVaultResponse.data.success) {
            keyVaultResult = keyVaultResponse.data.payload;
        }

        if (orgResponse.data.success && keyVaultResult) {
            this.setState({
                tableData: {
                    orgUUID: this.state.token.orgUUID,
                    bearerToken: keyVaultResult
                },
                disabled: false
            });
            this.props.modifyState("layerJotOrgIdentifier", this.state.token.orgUUID);
            this.hideEditModal();
        }
    }

    handleUserInput(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState(prevState => {
            const updatedToken = { ...prevState.token, [name]: value };
            const isSaveDisabled = !updatedToken.orgUUID || !updatedToken.bearerToken;

            return {
                token: updatedToken,
                isSaveDisabled: isSaveDisabled
            };
        });
    }

    render() {
        const { token, error, isSaveDisabled, tableData } = this.state;
        
        return (
            <div>
                <Modal bsSize="small" show={this.state.showDeleteModal}>
                    <Modal.Header>
                        <Modal.Title>Confirm Deletion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete the LayerJot token? Access to LayerJot within SPM will no longer work.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.hideDeleteModal} variant="default" type="button">Cancel</Button>
                        <Button onClick={this.handleDelete} variant="danger" type="button">Delete</Button>
                    </Modal.Footer>
                </Modal>
                <Modal bsSize="small" show={this.state.showEditModal}>
                    <Modal.Header>
                        <Modal.Title>
                            {this.state.layerjotModalHeaderText}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {error && <div className="alert alert-danger">{error}</div>}
                        <div className="form-group">
                            <label htmlFor="orgUUID">LayerJot Organization UUID</label>
                            <input
                                className="form-control"
                                type="text"
                                id="orgUUID"
                                name="orgUUID"
                                aria-describedby="orgUUIDHelp"
                                required
                                onChange={this.handleUserInput}
                                value={token.orgUUID}
                            />
                            <small id="orgUUIDHelp" className="form-text text-muted">Please enter the LayerJot Organization UUID.</small>
                        </div>
                        <div className="form-group">
                            <label htmlFor="bearerToken">LayerJot Bearer Token</label>
                            <input
                                className="form-control"
                                type="text"
                                id="bearerToken"
                                name="bearerToken"
                                aria-describedby="bearerTokenHelp"
                                required
                                onChange={this.handleUserInput}
                                value={token.bearerToken}
                            />
                            <small id="bearerTokenHelp" className="form-text text-muted">Please enter the LayerJot Bearer Token.</small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.hideEditModal} variant="warning" type="button">Cancel</Button>
                        <Button onClick={this.handleSave} variant="primary" type="button" disabled={isSaveDisabled}>Save</Button>
                    </Modal.Footer>
                </Modal>
                <Row>
                    <Col md={12}>
                        <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th>LayerJot Organization UUID</th>
                                    <th>Bearer Token</th>
                                    <th />
                                    <th />
                                    <th />
                                    <th>
                                        {!tableData.orgUUID && !tableData.bearerToken &&
                                            <span className="fa-layers fa-fw text-success float-right show-hand" onClick={this.showNewModal}>
                                                <FontAwesomeIcon icon={faKey} transform={{ rotate: -45 }} />
                                                <FontAwesomeIcon icon={faPlus} transform="shrink-8 right-10" />
                                            </span>
                                        }
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{tableData.orgUUID ? tableData.orgUUID : 'No LayerJotOrgIdentifier found in dbo.Organization'}</td>
                                    <td>{tableData.bearerToken ? tableData.bearerToken : 'No Bearer Token found in Azure Key Vault'}</td>
                                    <td className="table-fit"></td>
                                    <td className="table-fit"></td>
                                    {tableData.orgUUID || tableData.bearerToken ?
                                        (
                                            <>
                                                <td className="table-fit"><FontAwesomeIcon icon={faPen} className="gi-1-5x text-primary show-hand" onClick={this.showEditModal} /></td>
                                            </>
                                        ) : (
                                            <>
                                                <td className="table-fit"></td>
                                                <td className="table-fit"></td>
                                            </>
                                        )
                                    }
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default LayerJotToken;